import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./styles.scss";

const ChatStickyOverlay = ({ children, className = "", topOffsetPx = 8 }) => (
    <div
        className={classNames("chat-sticky-overlay", className)}
        aria-hidden="true"
        style={{ "--chat-sticky-overlay-top": `${Math.max(0, Number(topOffsetPx) || 0)}px` }}
    >
        <div className="chat-sticky-overlay__top-lane">
            {children}
        </div>
    </div>
);

ChatStickyOverlay.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    topOffsetPx: PropTypes.number,
};

export default ChatStickyOverlay;
